export default "__VITE_ASSET__Br5jejWP__"